/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root';
import { Route as IndexRouteImport } from './routes/index';
import { Route as authRouteRouteImport } from './routes/(auth)/route';
import { Route as AdminRouteImport } from './routes/admin';
import { Route as AppRouteImport } from './routes/app';
import { Route as OnboardingRouteImport } from './routes/onboarding';
import { Route as authForgotPasswordRouteImport } from './routes/(auth)/forgot-password';
import { Route as authLoginRouteImport } from './routes/(auth)/login';
import { Route as authRegisterRouteImport } from './routes/(auth)/register';
import { Route as authResetPasswordRouteImport } from './routes/(auth)/reset-password';
import { Route as authVerifyEmailRouteImport } from './routes/(auth)/verify-email';
import { Route as AdminIndexRouteImport } from './routes/admin/index';
import { Route as AdminAuditRouteImport } from './routes/admin/audit';
import { Route as AdminCatalogueRouteImport } from './routes/admin/catalogue';
import { Route as AdminOperationsRouteImport } from './routes/admin/operations';
import { Route as AppIndexRouteImport } from './routes/app/index';
import { Route as AppOrgIdRouteImport } from './routes/app/$orgId';
import { Route as authInviteTokenRouteImport } from './routes/(auth)/invite.$token';
import { Route as AdminClientsNewRouteImport } from './routes/admin/clients/new';
import { Route as AdminCustomersIndexRouteImport } from './routes/admin/customers/index';
import { Route as AdminCustomersOrganisationIdRouteImport } from './routes/admin/customers/$organisationId';
import { Route as AdminLicencesIndexRouteImport } from './routes/admin/licences/index';
import { Route as AdminLicencesLicenceIdRouteImport } from './routes/admin/licences/$licenceId';
import { Route as AppOrgIdIndexRouteImport } from './routes/app/$orgId/index';
import { Route as AppOrgIdAuditLogRouteImport } from './routes/app/$orgId/audit-log';
import { Route as AppOrgIdBillingRouteImport } from './routes/app/$orgId/billing';
import { Route as AppOrgIdContentRouteImport } from './routes/app/$orgId/content';
import { Route as AppOrgIdLicenceRouteImport } from './routes/app/$orgId/licence';
import { Route as AppOrgIdMediaRouteImport } from './routes/app/$orgId/media';
import { Route as AppOrgIdSettingsRouteImport } from './routes/app/$orgId/settings';
import { Route as AppOrgIdSitesRouteImport } from './routes/app/$orgId/sites';
import { Route as AppOrgIdTeamRouteImport } from './routes/app/$orgId/team';
import { Route as BillingCheckoutSimulateRouteImport } from './routes/billing/checkout.simulate';
import { Route as AppOrgIdSitesIndexRouteImport } from './routes/app/$orgId/sites/index';
import { Route as AppOrgIdSitesSiteIdRouteImport } from './routes/app/$orgId/sites/$siteId';
import { Route as AppOrgIdSitesSiteIdIndexRouteImport } from './routes/app/$orgId/sites/$siteId/index';
import { Route as AppOrgIdSitesSiteIdApiKeysRouteImport } from './routes/app/$orgId/sites/$siteId/api-keys';
import { Route as AppOrgIdSitesSiteIdContentRouteImport } from './routes/app/$orgId/sites/$siteId/content';
import { Route as AppOrgIdSitesSiteIdDomainsRouteImport } from './routes/app/$orgId/sites/$siteId/domains';
import { Route as AppOrgIdSitesSiteIdEditRouteImport } from './routes/app/$orgId/sites/$siteId/edit';
import { Route as AppOrgIdSitesSiteIdEnvironmentsRouteImport } from './routes/app/$orgId/sites/$siteId/environments';
import { Route as AppOrgIdSitesSiteIdMediaRouteImport } from './routes/app/$orgId/sites/$siteId/media';
import { Route as AppOrgIdSitesSiteIdPeopleRouteImport } from './routes/app/$orgId/sites/$siteId/people';
import { Route as AppOrgIdSitesSiteIdPublishRouteImport } from './routes/app/$orgId/sites/$siteId/publish';
import { Route as AppOrgIdSitesSiteIdSettingsRouteImport } from './routes/app/$orgId/sites/$siteId/settings';
import { Route as AppOrgIdSitesSiteIdPagesIndexRouteImport } from './routes/app/$orgId/sites/$siteId/pages/index';
import { Route as AppOrgIdSitesSiteIdPagesPageIdRouteImport } from './routes/app/$orgId/sites/$siteId/pages/$pageId';

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any);
const authRouteRoute = authRouteRouteImport.update({
  id: '/(auth)',
  getParentRoute: () => rootRouteImport,
} as any);
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any);
const AppRoute = AppRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any);
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any);
const authForgotPasswordRoute = authForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => authRouteRoute,
} as any);
const authLoginRoute = authLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => authRouteRoute,
} as any);
const authRegisterRoute = authRegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => authRouteRoute,
} as any);
const authResetPasswordRoute = authResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => authRouteRoute,
} as any);
const authVerifyEmailRoute = authVerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => authRouteRoute,
} as any);
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any);
const AdminAuditRoute = AdminAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AdminRoute,
} as any);
const AdminCatalogueRoute = AdminCatalogueRouteImport.update({
  id: '/catalogue',
  path: '/catalogue',
  getParentRoute: () => AdminRoute,
} as any);
const AdminOperationsRoute = AdminOperationsRouteImport.update({
  id: '/operations',
  path: '/operations',
  getParentRoute: () => AdminRoute,
} as any);
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any);
const AppOrgIdRoute = AppOrgIdRouteImport.update({
  id: '/$orgId',
  path: '/$orgId',
  getParentRoute: () => AppRoute,
} as any);
const authInviteTokenRoute = authInviteTokenRouteImport.update({
  id: '/invite/$token',
  path: '/invite/$token',
  getParentRoute: () => authRouteRoute,
} as any);
const AdminClientsNewRoute = AdminClientsNewRouteImport.update({
  id: '/clients/new',
  path: '/clients/new',
  getParentRoute: () => AdminRoute,
} as any);
const AdminCustomersIndexRoute = AdminCustomersIndexRouteImport.update({
  id: '/customers/',
  path: '/customers/',
  getParentRoute: () => AdminRoute,
} as any);
const AdminCustomersOrganisationIdRoute =
  AdminCustomersOrganisationIdRouteImport.update({
    id: '/customers/$organisationId',
    path: '/customers/$organisationId',
    getParentRoute: () => AdminRoute,
  } as any);
const AdminLicencesIndexRoute = AdminLicencesIndexRouteImport.update({
  id: '/licences/',
  path: '/licences/',
  getParentRoute: () => AdminRoute,
} as any);
const AdminLicencesLicenceIdRoute = AdminLicencesLicenceIdRouteImport.update({
  id: '/licences/$licenceId',
  path: '/licences/$licenceId',
  getParentRoute: () => AdminRoute,
} as any);
const AppOrgIdIndexRoute = AppOrgIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppOrgIdRoute,
} as any);
const AppOrgIdAuditLogRoute = AppOrgIdAuditLogRouteImport.update({
  id: '/audit-log',
  path: '/audit-log',
  getParentRoute: () => AppOrgIdRoute,
} as any);
const AppOrgIdBillingRoute = AppOrgIdBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => AppOrgIdRoute,
} as any);
const AppOrgIdContentRoute = AppOrgIdContentRouteImport.update({
  id: '/content',
  path: '/content',
  getParentRoute: () => AppOrgIdRoute,
} as any);
const AppOrgIdLicenceRoute = AppOrgIdLicenceRouteImport.update({
  id: '/licence',
  path: '/licence',
  getParentRoute: () => AppOrgIdRoute,
} as any);
const AppOrgIdMediaRoute = AppOrgIdMediaRouteImport.update({
  id: '/media',
  path: '/media',
  getParentRoute: () => AppOrgIdRoute,
} as any);
const AppOrgIdSettingsRoute = AppOrgIdSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppOrgIdRoute,
} as any);
const AppOrgIdSitesRoute = AppOrgIdSitesRouteImport.update({
  id: '/sites',
  path: '/sites',
  getParentRoute: () => AppOrgIdRoute,
} as any);
const AppOrgIdTeamRoute = AppOrgIdTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => AppOrgIdRoute,
} as any);
const BillingCheckoutSimulateRoute = BillingCheckoutSimulateRouteImport.update({
  id: '/billing/checkout/simulate',
  path: '/billing/checkout/simulate',
  getParentRoute: () => rootRouteImport,
} as any);
const AppOrgIdSitesIndexRoute = AppOrgIdSitesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppOrgIdSitesRoute,
} as any);
const AppOrgIdSitesSiteIdRoute = AppOrgIdSitesSiteIdRouteImport.update({
  id: '/$siteId',
  path: '/$siteId',
  getParentRoute: () => AppOrgIdSitesRoute,
} as any);
const AppOrgIdSitesSiteIdIndexRoute =
  AppOrgIdSitesSiteIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppOrgIdSitesSiteIdRoute,
  } as any);
const AppOrgIdSitesSiteIdApiKeysRoute =
  AppOrgIdSitesSiteIdApiKeysRouteImport.update({
    id: '/api-keys',
    path: '/api-keys',
    getParentRoute: () => AppOrgIdSitesSiteIdRoute,
  } as any);
const AppOrgIdSitesSiteIdContentRoute =
  AppOrgIdSitesSiteIdContentRouteImport.update({
    id: '/content',
    path: '/content',
    getParentRoute: () => AppOrgIdSitesSiteIdRoute,
  } as any);
const AppOrgIdSitesSiteIdDomainsRoute =
  AppOrgIdSitesSiteIdDomainsRouteImport.update({
    id: '/domains',
    path: '/domains',
    getParentRoute: () => AppOrgIdSitesSiteIdRoute,
  } as any);
const AppOrgIdSitesSiteIdEditRoute = AppOrgIdSitesSiteIdEditRouteImport.update({
  id: '/edit',
  path: '/edit',
  getParentRoute: () => AppOrgIdSitesSiteIdRoute,
} as any);
const AppOrgIdSitesSiteIdEnvironmentsRoute =
  AppOrgIdSitesSiteIdEnvironmentsRouteImport.update({
    id: '/environments',
    path: '/environments',
    getParentRoute: () => AppOrgIdSitesSiteIdRoute,
  } as any);
const AppOrgIdSitesSiteIdMediaRoute =
  AppOrgIdSitesSiteIdMediaRouteImport.update({
    id: '/media',
    path: '/media',
    getParentRoute: () => AppOrgIdSitesSiteIdRoute,
  } as any);
const AppOrgIdSitesSiteIdPeopleRoute =
  AppOrgIdSitesSiteIdPeopleRouteImport.update({
    id: '/people',
    path: '/people',
    getParentRoute: () => AppOrgIdSitesSiteIdRoute,
  } as any);
const AppOrgIdSitesSiteIdPublishRoute =
  AppOrgIdSitesSiteIdPublishRouteImport.update({
    id: '/publish',
    path: '/publish',
    getParentRoute: () => AppOrgIdSitesSiteIdRoute,
  } as any);
const AppOrgIdSitesSiteIdSettingsRoute =
  AppOrgIdSitesSiteIdSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AppOrgIdSitesSiteIdRoute,
  } as any);
const AppOrgIdSitesSiteIdPagesIndexRoute =
  AppOrgIdSitesSiteIdPagesIndexRouteImport.update({
    id: '/pages/',
    path: '/pages/',
    getParentRoute: () => AppOrgIdSitesSiteIdRoute,
  } as any);
const AppOrgIdSitesSiteIdPagesPageIdRoute =
  AppOrgIdSitesSiteIdPagesPageIdRouteImport.update({
    id: '/pages/$pageId',
    path: '/pages/$pageId',
    getParentRoute: () => AppOrgIdSitesSiteIdRoute,
  } as any);

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute;
  '/admin': typeof AdminRouteWithChildren;
  '/app': typeof AppRouteWithChildren;
  '/onboarding': typeof OnboardingRoute;
  '/forgot-password': typeof authForgotPasswordRoute;
  '/login': typeof authLoginRoute;
  '/register': typeof authRegisterRoute;
  '/reset-password': typeof authResetPasswordRoute;
  '/verify-email': typeof authVerifyEmailRoute;
  '/admin/audit': typeof AdminAuditRoute;
  '/admin/catalogue': typeof AdminCatalogueRoute;
  '/admin/operations': typeof AdminOperationsRoute;
  '/app/$orgId': typeof AppOrgIdRouteWithChildren;
  '/admin/': typeof AdminIndexRoute;
  '/app/': typeof AppIndexRoute;
  '/invite/$token': typeof authInviteTokenRoute;
  '/admin/clients/new': typeof AdminClientsNewRoute;
  '/admin/customers/$organisationId': typeof AdminCustomersOrganisationIdRoute;
  '/admin/licences/$licenceId': typeof AdminLicencesLicenceIdRoute;
  '/app/$orgId/audit-log': typeof AppOrgIdAuditLogRoute;
  '/app/$orgId/billing': typeof AppOrgIdBillingRoute;
  '/app/$orgId/content': typeof AppOrgIdContentRoute;
  '/app/$orgId/licence': typeof AppOrgIdLicenceRoute;
  '/app/$orgId/media': typeof AppOrgIdMediaRoute;
  '/app/$orgId/settings': typeof AppOrgIdSettingsRoute;
  '/app/$orgId/sites': typeof AppOrgIdSitesRouteWithChildren;
  '/app/$orgId/team': typeof AppOrgIdTeamRoute;
  '/billing/checkout/simulate': typeof BillingCheckoutSimulateRoute;
  '/admin/customers/': typeof AdminCustomersIndexRoute;
  '/admin/licences/': typeof AdminLicencesIndexRoute;
  '/app/$orgId/': typeof AppOrgIdIndexRoute;
  '/app/$orgId/sites/$siteId': typeof AppOrgIdSitesSiteIdRouteWithChildren;
  '/app/$orgId/sites/': typeof AppOrgIdSitesIndexRoute;
  '/app/$orgId/sites/$siteId/api-keys': typeof AppOrgIdSitesSiteIdApiKeysRoute;
  '/app/$orgId/sites/$siteId/content': typeof AppOrgIdSitesSiteIdContentRoute;
  '/app/$orgId/sites/$siteId/domains': typeof AppOrgIdSitesSiteIdDomainsRoute;
  '/app/$orgId/sites/$siteId/edit': typeof AppOrgIdSitesSiteIdEditRoute;
  '/app/$orgId/sites/$siteId/environments': typeof AppOrgIdSitesSiteIdEnvironmentsRoute;
  '/app/$orgId/sites/$siteId/media': typeof AppOrgIdSitesSiteIdMediaRoute;
  '/app/$orgId/sites/$siteId/people': typeof AppOrgIdSitesSiteIdPeopleRoute;
  '/app/$orgId/sites/$siteId/publish': typeof AppOrgIdSitesSiteIdPublishRoute;
  '/app/$orgId/sites/$siteId/settings': typeof AppOrgIdSitesSiteIdSettingsRoute;
  '/app/$orgId/sites/$siteId/': typeof AppOrgIdSitesSiteIdIndexRoute;
  '/app/$orgId/sites/$siteId/pages/$pageId': typeof AppOrgIdSitesSiteIdPagesPageIdRoute;
  '/app/$orgId/sites/$siteId/pages/': typeof AppOrgIdSitesSiteIdPagesIndexRoute;
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute;
  '/onboarding': typeof OnboardingRoute;
  '/forgot-password': typeof authForgotPasswordRoute;
  '/login': typeof authLoginRoute;
  '/register': typeof authRegisterRoute;
  '/reset-password': typeof authResetPasswordRoute;
  '/verify-email': typeof authVerifyEmailRoute;
  '/admin/audit': typeof AdminAuditRoute;
  '/admin/catalogue': typeof AdminCatalogueRoute;
  '/admin/operations': typeof AdminOperationsRoute;
  '/admin': typeof AdminIndexRoute;
  '/app': typeof AppIndexRoute;
  '/invite/$token': typeof authInviteTokenRoute;
  '/admin/clients/new': typeof AdminClientsNewRoute;
  '/admin/customers/$organisationId': typeof AdminCustomersOrganisationIdRoute;
  '/admin/licences/$licenceId': typeof AdminLicencesLicenceIdRoute;
  '/app/$orgId/audit-log': typeof AppOrgIdAuditLogRoute;
  '/app/$orgId/billing': typeof AppOrgIdBillingRoute;
  '/app/$orgId/content': typeof AppOrgIdContentRoute;
  '/app/$orgId/licence': typeof AppOrgIdLicenceRoute;
  '/app/$orgId/media': typeof AppOrgIdMediaRoute;
  '/app/$orgId/settings': typeof AppOrgIdSettingsRoute;
  '/app/$orgId/team': typeof AppOrgIdTeamRoute;
  '/billing/checkout/simulate': typeof BillingCheckoutSimulateRoute;
  '/admin/customers': typeof AdminCustomersIndexRoute;
  '/admin/licences': typeof AdminLicencesIndexRoute;
  '/app/$orgId': typeof AppOrgIdIndexRoute;
  '/app/$orgId/sites': typeof AppOrgIdSitesIndexRoute;
  '/app/$orgId/sites/$siteId/api-keys': typeof AppOrgIdSitesSiteIdApiKeysRoute;
  '/app/$orgId/sites/$siteId/content': typeof AppOrgIdSitesSiteIdContentRoute;
  '/app/$orgId/sites/$siteId/domains': typeof AppOrgIdSitesSiteIdDomainsRoute;
  '/app/$orgId/sites/$siteId/edit': typeof AppOrgIdSitesSiteIdEditRoute;
  '/app/$orgId/sites/$siteId/environments': typeof AppOrgIdSitesSiteIdEnvironmentsRoute;
  '/app/$orgId/sites/$siteId/media': typeof AppOrgIdSitesSiteIdMediaRoute;
  '/app/$orgId/sites/$siteId/people': typeof AppOrgIdSitesSiteIdPeopleRoute;
  '/app/$orgId/sites/$siteId/publish': typeof AppOrgIdSitesSiteIdPublishRoute;
  '/app/$orgId/sites/$siteId/settings': typeof AppOrgIdSitesSiteIdSettingsRoute;
  '/app/$orgId/sites/$siteId': typeof AppOrgIdSitesSiteIdIndexRoute;
  '/app/$orgId/sites/$siteId/pages/$pageId': typeof AppOrgIdSitesSiteIdPagesPageIdRoute;
  '/app/$orgId/sites/$siteId/pages': typeof AppOrgIdSitesSiteIdPagesIndexRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/': typeof IndexRoute;
  '/(auth)': typeof authRouteRouteWithChildren;
  '/admin': typeof AdminRouteWithChildren;
  '/app': typeof AppRouteWithChildren;
  '/onboarding': typeof OnboardingRoute;
  '/(auth)/forgot-password': typeof authForgotPasswordRoute;
  '/(auth)/login': typeof authLoginRoute;
  '/(auth)/register': typeof authRegisterRoute;
  '/(auth)/reset-password': typeof authResetPasswordRoute;
  '/(auth)/verify-email': typeof authVerifyEmailRoute;
  '/admin/audit': typeof AdminAuditRoute;
  '/admin/catalogue': typeof AdminCatalogueRoute;
  '/admin/operations': typeof AdminOperationsRoute;
  '/app/$orgId': typeof AppOrgIdRouteWithChildren;
  '/admin/': typeof AdminIndexRoute;
  '/app/': typeof AppIndexRoute;
  '/(auth)/invite/$token': typeof authInviteTokenRoute;
  '/admin/clients/new': typeof AdminClientsNewRoute;
  '/admin/customers/$organisationId': typeof AdminCustomersOrganisationIdRoute;
  '/admin/licences/$licenceId': typeof AdminLicencesLicenceIdRoute;
  '/app/$orgId/audit-log': typeof AppOrgIdAuditLogRoute;
  '/app/$orgId/billing': typeof AppOrgIdBillingRoute;
  '/app/$orgId/content': typeof AppOrgIdContentRoute;
  '/app/$orgId/licence': typeof AppOrgIdLicenceRoute;
  '/app/$orgId/media': typeof AppOrgIdMediaRoute;
  '/app/$orgId/settings': typeof AppOrgIdSettingsRoute;
  '/app/$orgId/sites': typeof AppOrgIdSitesRouteWithChildren;
  '/app/$orgId/team': typeof AppOrgIdTeamRoute;
  '/billing/checkout/simulate': typeof BillingCheckoutSimulateRoute;
  '/admin/customers/': typeof AdminCustomersIndexRoute;
  '/admin/licences/': typeof AdminLicencesIndexRoute;
  '/app/$orgId/': typeof AppOrgIdIndexRoute;
  '/app/$orgId/sites/$siteId': typeof AppOrgIdSitesSiteIdRouteWithChildren;
  '/app/$orgId/sites/': typeof AppOrgIdSitesIndexRoute;
  '/app/$orgId/sites/$siteId/api-keys': typeof AppOrgIdSitesSiteIdApiKeysRoute;
  '/app/$orgId/sites/$siteId/content': typeof AppOrgIdSitesSiteIdContentRoute;
  '/app/$orgId/sites/$siteId/domains': typeof AppOrgIdSitesSiteIdDomainsRoute;
  '/app/$orgId/sites/$siteId/edit': typeof AppOrgIdSitesSiteIdEditRoute;
  '/app/$orgId/sites/$siteId/environments': typeof AppOrgIdSitesSiteIdEnvironmentsRoute;
  '/app/$orgId/sites/$siteId/media': typeof AppOrgIdSitesSiteIdMediaRoute;
  '/app/$orgId/sites/$siteId/people': typeof AppOrgIdSitesSiteIdPeopleRoute;
  '/app/$orgId/sites/$siteId/publish': typeof AppOrgIdSitesSiteIdPublishRoute;
  '/app/$orgId/sites/$siteId/settings': typeof AppOrgIdSitesSiteIdSettingsRoute;
  '/app/$orgId/sites/$siteId/': typeof AppOrgIdSitesSiteIdIndexRoute;
  '/app/$orgId/sites/$siteId/pages/$pageId': typeof AppOrgIdSitesSiteIdPagesPageIdRoute;
  '/app/$orgId/sites/$siteId/pages/': typeof AppOrgIdSitesSiteIdPagesIndexRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/admin'
    | '/app'
    | '/onboarding'
    | '/forgot-password'
    | '/login'
    | '/register'
    | '/reset-password'
    | '/verify-email'
    | '/admin/audit'
    | '/admin/catalogue'
    | '/admin/operations'
    | '/app/$orgId'
    | '/admin/'
    | '/app/'
    | '/invite/$token'
    | '/admin/clients/new'
    | '/admin/customers/$organisationId'
    | '/admin/licences/$licenceId'
    | '/app/$orgId/audit-log'
    | '/app/$orgId/billing'
    | '/app/$orgId/content'
    | '/app/$orgId/licence'
    | '/app/$orgId/media'
    | '/app/$orgId/settings'
    | '/app/$orgId/sites'
    | '/app/$orgId/team'
    | '/billing/checkout/simulate'
    | '/admin/customers/'
    | '/admin/licences/'
    | '/app/$orgId/'
    | '/app/$orgId/sites/$siteId'
    | '/app/$orgId/sites/'
    | '/app/$orgId/sites/$siteId/api-keys'
    | '/app/$orgId/sites/$siteId/content'
    | '/app/$orgId/sites/$siteId/domains'
    | '/app/$orgId/sites/$siteId/edit'
    | '/app/$orgId/sites/$siteId/environments'
    | '/app/$orgId/sites/$siteId/media'
    | '/app/$orgId/sites/$siteId/people'
    | '/app/$orgId/sites/$siteId/publish'
    | '/app/$orgId/sites/$siteId/settings'
    | '/app/$orgId/sites/$siteId/'
    | '/app/$orgId/sites/$siteId/pages/$pageId'
    | '/app/$orgId/sites/$siteId/pages/';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/'
    | '/onboarding'
    | '/forgot-password'
    | '/login'
    | '/register'
    | '/reset-password'
    | '/verify-email'
    | '/admin/audit'
    | '/admin/catalogue'
    | '/admin/operations'
    | '/admin'
    | '/app'
    | '/invite/$token'
    | '/admin/clients/new'
    | '/admin/customers/$organisationId'
    | '/admin/licences/$licenceId'
    | '/app/$orgId/audit-log'
    | '/app/$orgId/billing'
    | '/app/$orgId/content'
    | '/app/$orgId/licence'
    | '/app/$orgId/media'
    | '/app/$orgId/settings'
    | '/app/$orgId/team'
    | '/billing/checkout/simulate'
    | '/admin/customers'
    | '/admin/licences'
    | '/app/$orgId'
    | '/app/$orgId/sites'
    | '/app/$orgId/sites/$siteId/api-keys'
    | '/app/$orgId/sites/$siteId/content'
    | '/app/$orgId/sites/$siteId/domains'
    | '/app/$orgId/sites/$siteId/edit'
    | '/app/$orgId/sites/$siteId/environments'
    | '/app/$orgId/sites/$siteId/media'
    | '/app/$orgId/sites/$siteId/people'
    | '/app/$orgId/sites/$siteId/publish'
    | '/app/$orgId/sites/$siteId/settings'
    | '/app/$orgId/sites/$siteId'
    | '/app/$orgId/sites/$siteId/pages/$pageId'
    | '/app/$orgId/sites/$siteId/pages';
  id:
    | '__root__'
    | '/'
    | '/(auth)'
    | '/admin'
    | '/app'
    | '/onboarding'
    | '/(auth)/forgot-password'
    | '/(auth)/login'
    | '/(auth)/register'
    | '/(auth)/reset-password'
    | '/(auth)/verify-email'
    | '/admin/audit'
    | '/admin/catalogue'
    | '/admin/operations'
    | '/app/$orgId'
    | '/admin/'
    | '/app/'
    | '/(auth)/invite/$token'
    | '/admin/clients/new'
    | '/admin/customers/$organisationId'
    | '/admin/licences/$licenceId'
    | '/app/$orgId/audit-log'
    | '/app/$orgId/billing'
    | '/app/$orgId/content'
    | '/app/$orgId/licence'
    | '/app/$orgId/media'
    | '/app/$orgId/settings'
    | '/app/$orgId/sites'
    | '/app/$orgId/team'
    | '/billing/checkout/simulate'
    | '/admin/customers/'
    | '/admin/licences/'
    | '/app/$orgId/'
    | '/app/$orgId/sites/$siteId'
    | '/app/$orgId/sites/'
    | '/app/$orgId/sites/$siteId/api-keys'
    | '/app/$orgId/sites/$siteId/content'
    | '/app/$orgId/sites/$siteId/domains'
    | '/app/$orgId/sites/$siteId/edit'
    | '/app/$orgId/sites/$siteId/environments'
    | '/app/$orgId/sites/$siteId/media'
    | '/app/$orgId/sites/$siteId/people'
    | '/app/$orgId/sites/$siteId/publish'
    | '/app/$orgId/sites/$siteId/settings'
    | '/app/$orgId/sites/$siteId/'
    | '/app/$orgId/sites/$siteId/pages/$pageId'
    | '/app/$orgId/sites/$siteId/pages/';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  authRouteRoute: typeof authRouteRouteWithChildren;
  AdminRoute: typeof AdminRouteWithChildren;
  AppRoute: typeof AppRouteWithChildren;
  OnboardingRoute: typeof OnboardingRoute;
  BillingCheckoutSimulateRoute: typeof BillingCheckoutSimulateRoute;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(auth)': {
      id: '/(auth)';
      path: '';
      fullPath: '';
      preLoaderRoute: typeof authRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/admin': {
      id: '/admin';
      path: '/admin';
      fullPath: '/admin';
      preLoaderRoute: typeof AdminRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/app': {
      id: '/app';
      path: '/app';
      fullPath: '/app';
      preLoaderRoute: typeof AppRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/onboarding': {
      id: '/onboarding';
      path: '/onboarding';
      fullPath: '/onboarding';
      preLoaderRoute: typeof OnboardingRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(auth)/forgot-password': {
      id: '/(auth)/forgot-password';
      path: '/forgot-password';
      fullPath: '/forgot-password';
      preLoaderRoute: typeof authForgotPasswordRouteImport;
      parentRoute: typeof authRouteRoute;
    };
    '/(auth)/login': {
      id: '/(auth)/login';
      path: '/login';
      fullPath: '/login';
      preLoaderRoute: typeof authLoginRouteImport;
      parentRoute: typeof authRouteRoute;
    };
    '/(auth)/register': {
      id: '/(auth)/register';
      path: '/register';
      fullPath: '/register';
      preLoaderRoute: typeof authRegisterRouteImport;
      parentRoute: typeof authRouteRoute;
    };
    '/(auth)/reset-password': {
      id: '/(auth)/reset-password';
      path: '/reset-password';
      fullPath: '/reset-password';
      preLoaderRoute: typeof authResetPasswordRouteImport;
      parentRoute: typeof authRouteRoute;
    };
    '/(auth)/verify-email': {
      id: '/(auth)/verify-email';
      path: '/verify-email';
      fullPath: '/verify-email';
      preLoaderRoute: typeof authVerifyEmailRouteImport;
      parentRoute: typeof authRouteRoute;
    };
    '/admin/': {
      id: '/admin/';
      path: '/';
      fullPath: '/admin/';
      preLoaderRoute: typeof AdminIndexRouteImport;
      parentRoute: typeof AdminRoute;
    };
    '/admin/audit': {
      id: '/admin/audit';
      path: '/audit';
      fullPath: '/admin/audit';
      preLoaderRoute: typeof AdminAuditRouteImport;
      parentRoute: typeof AdminRoute;
    };
    '/admin/catalogue': {
      id: '/admin/catalogue';
      path: '/catalogue';
      fullPath: '/admin/catalogue';
      preLoaderRoute: typeof AdminCatalogueRouteImport;
      parentRoute: typeof AdminRoute;
    };
    '/admin/operations': {
      id: '/admin/operations';
      path: '/operations';
      fullPath: '/admin/operations';
      preLoaderRoute: typeof AdminOperationsRouteImport;
      parentRoute: typeof AdminRoute;
    };
    '/app/': {
      id: '/app/';
      path: '/';
      fullPath: '/app/';
      preLoaderRoute: typeof AppIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/app/$orgId': {
      id: '/app/$orgId';
      path: '/$orgId';
      fullPath: '/app/$orgId';
      preLoaderRoute: typeof AppOrgIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/(auth)/invite/$token': {
      id: '/(auth)/invite/$token';
      path: '/invite/$token';
      fullPath: '/invite/$token';
      preLoaderRoute: typeof authInviteTokenRouteImport;
      parentRoute: typeof authRouteRoute;
    };
    '/admin/clients/new': {
      id: '/admin/clients/new';
      path: '/clients/new';
      fullPath: '/admin/clients/new';
      preLoaderRoute: typeof AdminClientsNewRouteImport;
      parentRoute: typeof AdminRoute;
    };
    '/admin/customers/': {
      id: '/admin/customers/';
      path: '/customers';
      fullPath: '/admin/customers/';
      preLoaderRoute: typeof AdminCustomersIndexRouteImport;
      parentRoute: typeof AdminRoute;
    };
    '/admin/customers/$organisationId': {
      id: '/admin/customers/$organisationId';
      path: '/customers/$organisationId';
      fullPath: '/admin/customers/$organisationId';
      preLoaderRoute: typeof AdminCustomersOrganisationIdRouteImport;
      parentRoute: typeof AdminRoute;
    };
    '/admin/licences/': {
      id: '/admin/licences/';
      path: '/licences';
      fullPath: '/admin/licences/';
      preLoaderRoute: typeof AdminLicencesIndexRouteImport;
      parentRoute: typeof AdminRoute;
    };
    '/admin/licences/$licenceId': {
      id: '/admin/licences/$licenceId';
      path: '/licences/$licenceId';
      fullPath: '/admin/licences/$licenceId';
      preLoaderRoute: typeof AdminLicencesLicenceIdRouteImport;
      parentRoute: typeof AdminRoute;
    };
    '/app/$orgId/': {
      id: '/app/$orgId/';
      path: '/';
      fullPath: '/app/$orgId/';
      preLoaderRoute: typeof AppOrgIdIndexRouteImport;
      parentRoute: typeof AppOrgIdRoute;
    };
    '/app/$orgId/audit-log': {
      id: '/app/$orgId/audit-log';
      path: '/audit-log';
      fullPath: '/app/$orgId/audit-log';
      preLoaderRoute: typeof AppOrgIdAuditLogRouteImport;
      parentRoute: typeof AppOrgIdRoute;
    };
    '/app/$orgId/billing': {
      id: '/app/$orgId/billing';
      path: '/billing';
      fullPath: '/app/$orgId/billing';
      preLoaderRoute: typeof AppOrgIdBillingRouteImport;
      parentRoute: typeof AppOrgIdRoute;
    };
    '/app/$orgId/content': {
      id: '/app/$orgId/content';
      path: '/content';
      fullPath: '/app/$orgId/content';
      preLoaderRoute: typeof AppOrgIdContentRouteImport;
      parentRoute: typeof AppOrgIdRoute;
    };
    '/app/$orgId/licence': {
      id: '/app/$orgId/licence';
      path: '/licence';
      fullPath: '/app/$orgId/licence';
      preLoaderRoute: typeof AppOrgIdLicenceRouteImport;
      parentRoute: typeof AppOrgIdRoute;
    };
    '/app/$orgId/media': {
      id: '/app/$orgId/media';
      path: '/media';
      fullPath: '/app/$orgId/media';
      preLoaderRoute: typeof AppOrgIdMediaRouteImport;
      parentRoute: typeof AppOrgIdRoute;
    };
    '/app/$orgId/settings': {
      id: '/app/$orgId/settings';
      path: '/settings';
      fullPath: '/app/$orgId/settings';
      preLoaderRoute: typeof AppOrgIdSettingsRouteImport;
      parentRoute: typeof AppOrgIdRoute;
    };
    '/app/$orgId/sites': {
      id: '/app/$orgId/sites';
      path: '/sites';
      fullPath: '/app/$orgId/sites';
      preLoaderRoute: typeof AppOrgIdSitesRouteImport;
      parentRoute: typeof AppOrgIdRoute;
    };
    '/app/$orgId/team': {
      id: '/app/$orgId/team';
      path: '/team';
      fullPath: '/app/$orgId/team';
      preLoaderRoute: typeof AppOrgIdTeamRouteImport;
      parentRoute: typeof AppOrgIdRoute;
    };
    '/billing/checkout/simulate': {
      id: '/billing/checkout/simulate';
      path: '/billing/checkout/simulate';
      fullPath: '/billing/checkout/simulate';
      preLoaderRoute: typeof BillingCheckoutSimulateRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/app/$orgId/sites/': {
      id: '/app/$orgId/sites/';
      path: '/';
      fullPath: '/app/$orgId/sites/';
      preLoaderRoute: typeof AppOrgIdSitesIndexRouteImport;
      parentRoute: typeof AppOrgIdSitesRoute;
    };
    '/app/$orgId/sites/$siteId': {
      id: '/app/$orgId/sites/$siteId';
      path: '/$siteId';
      fullPath: '/app/$orgId/sites/$siteId';
      preLoaderRoute: typeof AppOrgIdSitesSiteIdRouteImport;
      parentRoute: typeof AppOrgIdSitesRoute;
    };
    '/app/$orgId/sites/$siteId/': {
      id: '/app/$orgId/sites/$siteId/';
      path: '/';
      fullPath: '/app/$orgId/sites/$siteId/';
      preLoaderRoute: typeof AppOrgIdSitesSiteIdIndexRouteImport;
      parentRoute: typeof AppOrgIdSitesSiteIdRoute;
    };
    '/app/$orgId/sites/$siteId/api-keys': {
      id: '/app/$orgId/sites/$siteId/api-keys';
      path: '/api-keys';
      fullPath: '/app/$orgId/sites/$siteId/api-keys';
      preLoaderRoute: typeof AppOrgIdSitesSiteIdApiKeysRouteImport;
      parentRoute: typeof AppOrgIdSitesSiteIdRoute;
    };
    '/app/$orgId/sites/$siteId/content': {
      id: '/app/$orgId/sites/$siteId/content';
      path: '/content';
      fullPath: '/app/$orgId/sites/$siteId/content';
      preLoaderRoute: typeof AppOrgIdSitesSiteIdContentRouteImport;
      parentRoute: typeof AppOrgIdSitesSiteIdRoute;
    };
    '/app/$orgId/sites/$siteId/domains': {
      id: '/app/$orgId/sites/$siteId/domains';
      path: '/domains';
      fullPath: '/app/$orgId/sites/$siteId/domains';
      preLoaderRoute: typeof AppOrgIdSitesSiteIdDomainsRouteImport;
      parentRoute: typeof AppOrgIdSitesSiteIdRoute;
    };
    '/app/$orgId/sites/$siteId/edit': {
      id: '/app/$orgId/sites/$siteId/edit';
      path: '/edit';
      fullPath: '/app/$orgId/sites/$siteId/edit';
      preLoaderRoute: typeof AppOrgIdSitesSiteIdEditRouteImport;
      parentRoute: typeof AppOrgIdSitesSiteIdRoute;
    };
    '/app/$orgId/sites/$siteId/environments': {
      id: '/app/$orgId/sites/$siteId/environments';
      path: '/environments';
      fullPath: '/app/$orgId/sites/$siteId/environments';
      preLoaderRoute: typeof AppOrgIdSitesSiteIdEnvironmentsRouteImport;
      parentRoute: typeof AppOrgIdSitesSiteIdRoute;
    };
    '/app/$orgId/sites/$siteId/media': {
      id: '/app/$orgId/sites/$siteId/media';
      path: '/media';
      fullPath: '/app/$orgId/sites/$siteId/media';
      preLoaderRoute: typeof AppOrgIdSitesSiteIdMediaRouteImport;
      parentRoute: typeof AppOrgIdSitesSiteIdRoute;
    };
    '/app/$orgId/sites/$siteId/people': {
      id: '/app/$orgId/sites/$siteId/people';
      path: '/people';
      fullPath: '/app/$orgId/sites/$siteId/people';
      preLoaderRoute: typeof AppOrgIdSitesSiteIdPeopleRouteImport;
      parentRoute: typeof AppOrgIdSitesSiteIdRoute;
    };
    '/app/$orgId/sites/$siteId/publish': {
      id: '/app/$orgId/sites/$siteId/publish';
      path: '/publish';
      fullPath: '/app/$orgId/sites/$siteId/publish';
      preLoaderRoute: typeof AppOrgIdSitesSiteIdPublishRouteImport;
      parentRoute: typeof AppOrgIdSitesSiteIdRoute;
    };
    '/app/$orgId/sites/$siteId/settings': {
      id: '/app/$orgId/sites/$siteId/settings';
      path: '/settings';
      fullPath: '/app/$orgId/sites/$siteId/settings';
      preLoaderRoute: typeof AppOrgIdSitesSiteIdSettingsRouteImport;
      parentRoute: typeof AppOrgIdSitesSiteIdRoute;
    };
    '/app/$orgId/sites/$siteId/pages/': {
      id: '/app/$orgId/sites/$siteId/pages/';
      path: '/pages';
      fullPath: '/app/$orgId/sites/$siteId/pages/';
      preLoaderRoute: typeof AppOrgIdSitesSiteIdPagesIndexRouteImport;
      parentRoute: typeof AppOrgIdSitesSiteIdRoute;
    };
    '/app/$orgId/sites/$siteId/pages/$pageId': {
      id: '/app/$orgId/sites/$siteId/pages/$pageId';
      path: '/pages/$pageId';
      fullPath: '/app/$orgId/sites/$siteId/pages/$pageId';
      preLoaderRoute: typeof AppOrgIdSitesSiteIdPagesPageIdRouteImport;
      parentRoute: typeof AppOrgIdSitesSiteIdRoute;
    };
  }
}

interface authRouteRouteChildren {
  authForgotPasswordRoute: typeof authForgotPasswordRoute;
  authLoginRoute: typeof authLoginRoute;
  authRegisterRoute: typeof authRegisterRoute;
  authResetPasswordRoute: typeof authResetPasswordRoute;
  authVerifyEmailRoute: typeof authVerifyEmailRoute;
  authInviteTokenRoute: typeof authInviteTokenRoute;
}

const authRouteRouteChildren: authRouteRouteChildren = {
  authForgotPasswordRoute: authForgotPasswordRoute,
  authLoginRoute: authLoginRoute,
  authRegisterRoute: authRegisterRoute,
  authResetPasswordRoute: authResetPasswordRoute,
  authVerifyEmailRoute: authVerifyEmailRoute,
  authInviteTokenRoute: authInviteTokenRoute,
};

const authRouteRouteWithChildren = authRouteRoute._addFileChildren(
  authRouteRouteChildren,
);

interface AdminRouteChildren {
  AdminAuditRoute: typeof AdminAuditRoute;
  AdminCatalogueRoute: typeof AdminCatalogueRoute;
  AdminOperationsRoute: typeof AdminOperationsRoute;
  AdminIndexRoute: typeof AdminIndexRoute;
  AdminClientsNewRoute: typeof AdminClientsNewRoute;
  AdminCustomersOrganisationIdRoute: typeof AdminCustomersOrganisationIdRoute;
  AdminLicencesLicenceIdRoute: typeof AdminLicencesLicenceIdRoute;
  AdminCustomersIndexRoute: typeof AdminCustomersIndexRoute;
  AdminLicencesIndexRoute: typeof AdminLicencesIndexRoute;
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminAuditRoute: AdminAuditRoute,
  AdminCatalogueRoute: AdminCatalogueRoute,
  AdminOperationsRoute: AdminOperationsRoute,
  AdminIndexRoute: AdminIndexRoute,
  AdminClientsNewRoute: AdminClientsNewRoute,
  AdminCustomersOrganisationIdRoute: AdminCustomersOrganisationIdRoute,
  AdminLicencesLicenceIdRoute: AdminLicencesLicenceIdRoute,
  AdminCustomersIndexRoute: AdminCustomersIndexRoute,
  AdminLicencesIndexRoute: AdminLicencesIndexRoute,
};

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren);

interface AppOrgIdSitesSiteIdRouteChildren {
  AppOrgIdSitesSiteIdApiKeysRoute: typeof AppOrgIdSitesSiteIdApiKeysRoute;
  AppOrgIdSitesSiteIdContentRoute: typeof AppOrgIdSitesSiteIdContentRoute;
  AppOrgIdSitesSiteIdDomainsRoute: typeof AppOrgIdSitesSiteIdDomainsRoute;
  AppOrgIdSitesSiteIdEditRoute: typeof AppOrgIdSitesSiteIdEditRoute;
  AppOrgIdSitesSiteIdEnvironmentsRoute: typeof AppOrgIdSitesSiteIdEnvironmentsRoute;
  AppOrgIdSitesSiteIdMediaRoute: typeof AppOrgIdSitesSiteIdMediaRoute;
  AppOrgIdSitesSiteIdPeopleRoute: typeof AppOrgIdSitesSiteIdPeopleRoute;
  AppOrgIdSitesSiteIdPublishRoute: typeof AppOrgIdSitesSiteIdPublishRoute;
  AppOrgIdSitesSiteIdSettingsRoute: typeof AppOrgIdSitesSiteIdSettingsRoute;
  AppOrgIdSitesSiteIdIndexRoute: typeof AppOrgIdSitesSiteIdIndexRoute;
  AppOrgIdSitesSiteIdPagesPageIdRoute: typeof AppOrgIdSitesSiteIdPagesPageIdRoute;
  AppOrgIdSitesSiteIdPagesIndexRoute: typeof AppOrgIdSitesSiteIdPagesIndexRoute;
}

const AppOrgIdSitesSiteIdRouteChildren: AppOrgIdSitesSiteIdRouteChildren = {
  AppOrgIdSitesSiteIdApiKeysRoute: AppOrgIdSitesSiteIdApiKeysRoute,
  AppOrgIdSitesSiteIdContentRoute: AppOrgIdSitesSiteIdContentRoute,
  AppOrgIdSitesSiteIdDomainsRoute: AppOrgIdSitesSiteIdDomainsRoute,
  AppOrgIdSitesSiteIdEditRoute: AppOrgIdSitesSiteIdEditRoute,
  AppOrgIdSitesSiteIdEnvironmentsRoute: AppOrgIdSitesSiteIdEnvironmentsRoute,
  AppOrgIdSitesSiteIdMediaRoute: AppOrgIdSitesSiteIdMediaRoute,
  AppOrgIdSitesSiteIdPeopleRoute: AppOrgIdSitesSiteIdPeopleRoute,
  AppOrgIdSitesSiteIdPublishRoute: AppOrgIdSitesSiteIdPublishRoute,
  AppOrgIdSitesSiteIdSettingsRoute: AppOrgIdSitesSiteIdSettingsRoute,
  AppOrgIdSitesSiteIdIndexRoute: AppOrgIdSitesSiteIdIndexRoute,
  AppOrgIdSitesSiteIdPagesPageIdRoute: AppOrgIdSitesSiteIdPagesPageIdRoute,
  AppOrgIdSitesSiteIdPagesIndexRoute: AppOrgIdSitesSiteIdPagesIndexRoute,
};

const AppOrgIdSitesSiteIdRouteWithChildren =
  AppOrgIdSitesSiteIdRoute._addFileChildren(AppOrgIdSitesSiteIdRouteChildren);

interface AppOrgIdSitesRouteChildren {
  AppOrgIdSitesSiteIdRoute: typeof AppOrgIdSitesSiteIdRouteWithChildren;
  AppOrgIdSitesIndexRoute: typeof AppOrgIdSitesIndexRoute;
}

const AppOrgIdSitesRouteChildren: AppOrgIdSitesRouteChildren = {
  AppOrgIdSitesSiteIdRoute: AppOrgIdSitesSiteIdRouteWithChildren,
  AppOrgIdSitesIndexRoute: AppOrgIdSitesIndexRoute,
};

const AppOrgIdSitesRouteWithChildren = AppOrgIdSitesRoute._addFileChildren(
  AppOrgIdSitesRouteChildren,
);

interface AppOrgIdRouteChildren {
  AppOrgIdAuditLogRoute: typeof AppOrgIdAuditLogRoute;
  AppOrgIdBillingRoute: typeof AppOrgIdBillingRoute;
  AppOrgIdContentRoute: typeof AppOrgIdContentRoute;
  AppOrgIdLicenceRoute: typeof AppOrgIdLicenceRoute;
  AppOrgIdMediaRoute: typeof AppOrgIdMediaRoute;
  AppOrgIdSettingsRoute: typeof AppOrgIdSettingsRoute;
  AppOrgIdSitesRoute: typeof AppOrgIdSitesRouteWithChildren;
  AppOrgIdTeamRoute: typeof AppOrgIdTeamRoute;
  AppOrgIdIndexRoute: typeof AppOrgIdIndexRoute;
}

const AppOrgIdRouteChildren: AppOrgIdRouteChildren = {
  AppOrgIdAuditLogRoute: AppOrgIdAuditLogRoute,
  AppOrgIdBillingRoute: AppOrgIdBillingRoute,
  AppOrgIdContentRoute: AppOrgIdContentRoute,
  AppOrgIdLicenceRoute: AppOrgIdLicenceRoute,
  AppOrgIdMediaRoute: AppOrgIdMediaRoute,
  AppOrgIdSettingsRoute: AppOrgIdSettingsRoute,
  AppOrgIdSitesRoute: AppOrgIdSitesRouteWithChildren,
  AppOrgIdTeamRoute: AppOrgIdTeamRoute,
  AppOrgIdIndexRoute: AppOrgIdIndexRoute,
};

const AppOrgIdRouteWithChildren = AppOrgIdRoute._addFileChildren(
  AppOrgIdRouteChildren,
);

interface AppRouteChildren {
  AppOrgIdRoute: typeof AppOrgIdRouteWithChildren;
  AppIndexRoute: typeof AppIndexRoute;
}

const AppRouteChildren: AppRouteChildren = {
  AppOrgIdRoute: AppOrgIdRouteWithChildren,
  AppIndexRoute: AppIndexRoute,
};

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren);

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  authRouteRoute: authRouteRouteWithChildren,
  AdminRoute: AdminRouteWithChildren,
  AppRoute: AppRouteWithChildren,
  OnboardingRoute: OnboardingRoute,
  BillingCheckoutSimulateRoute: BillingCheckoutSimulateRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
